import { logoutUser } from '../redux/actions/authActions';
import { interceptors } from 'axios';
import { ToastsStore } from 'react-toasts';

export const setupInterceptors = (store) => {
    interceptors.response.use(
        function (response) {
            return Promise.resolve(response);
        },
        function (error) {
            if (error.response.status === 401) {
                //logout user
                store.dispatch(logoutUser());

                //Redirect to loginx
                window.location.href = '/login';
            } else if (error.response.status === 429) {
                ToastsStore.error(error.response.data);
                return Promise.reject(error);
            } else {
                // console.clear()
                return Promise.reject(error);
            }
        }
    );
};
